const modeKey = "stub:adminPlan:mode";
const errorMessageKey = "stub:adminPlan:errorMessage";

const getStorageValue = (key) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }
  return window.localStorage.getItem(key);
};

export const getAdminPlanStubMode = () => {
  const mode = getStorageValue(modeKey);
  return mode === "error" ? "error" : "success";
};

export const getAdminPlanStubErrorMessage = () => {
  const message = getStorageValue(errorMessageKey);
  return typeof message === "string" && message.trim() !== ""
    ? message
    : "Network error. Please check your internet connection.";
};
